import styled from "styled-components";

export const Main = styled.div`
   display: flex;
   flex-direction: column;
   height: 100vh;
   background-color: #fff;

   .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #cee5fd;
      padding: 0 15px;

      h3 {
         display: flex;
         align-items: center;
         font-weight: 400;
         height: 50px;
         font-size: 20px;
      }
      svg {
         font-size: 22px;
         opacity: 0.65;
         transition: all .2s ease-in-out;
         cursor: pointer;

         &:hover {
            opacity: 0.4;
         }
      }
   }
   .scroll {
      height: 100%;
      overflow: auto;
      margin-bottom: 7.5px;
      padding: 15px;

      .empty {
         display: flex;
         justify-content: center;
         align-items: center;
         height: 100%;
         font-size: 15px;
         opacity: 0.5;
      }
      .item {
         display: flex;
        
         &:not(:last-of-type) {
            margin-bottom: 15px;
         }
         img {
            border-radius: 5px;
            width: 35px;
            height: 35px;
         }
         img {
            width: 40px;
            height: 40px;
            object-fit: cover;
            border-radius: 5px;
            margin-right: 15px;
         }
         pre {
            white-space: pre-wrap;
            word-break: break-word;
            overflow-wrap: break-word;

            span:first-of-type {
               display: block;
               font-weight: 500;
               margin-top: -3px;
               font-size: 14px;
            }
            span:last-of-type {
               opacity: 0.85;
               font-size: 14px;
            }
         }
      }
   }
   .action {
      position: relative;

      textarea {
         position: relative;
         top: 5px;
         padding: 18px 70px 15px 15px;
         background-color: rgb(243, 244, 246);
         border: none;
         width: 100%;
         min-height: 55px;
         height: 55px;
         max-height: 100px;
         resize: none;
         font-size: 15px;

         &::-webkit-scrollbar {
            width: 0;
         }
         &::placeholder {
            color: #000;
            opacity: 0.5;
            white-space: nowrap;
         }
      }
      button {
         position: absolute;
         bottom: 10px;
         right: 15px;
         display: flex;
         align-items: center;
         justify-content: center;
         color: #fff;
         width: 40px;
         height: 35px;
         font-size: 23px;
         border: none;
         border-radius: 5px;
         background-color: #1E272E;

         &.loading svg {
            animation: loading 1.1s infinite linear;

            @keyframes loading  {
               0% { transform: rotate(0deg); }
               100% { transform: rotate(360deg); }
            }
         }
         &:disabled {
            background-color: #BEC1C4;
         }
      }
   }
`;